"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFeatureEnabledFactory = exports.isFeatureEnabled = void 0;
var providers_1 = require("./providers");
function isFeatureEnabled(name, providers) {
    if (providers === void 0) { providers = [
        providers_1.locationSearchFeatureProvider,
        providers_1.localStorageFeatureProvider,
        providers_1.sessionStorageFeatureProvider
    ]; }
    return providers.some(function (isEnabled) { return isEnabled(name); });
}
exports.isFeatureEnabled = isFeatureEnabled;
var isFeatureEnabledFactory = function () {
    var providers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        providers[_i] = arguments[_i];
    }
    return function (name) { return isFeatureEnabled(name, providers); };
};
exports.isFeatureEnabledFactory = isFeatureEnabledFactory;
